"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleSelectionButtons = void 0;
const React = require("react");
const react_1 = require("react");
const ExtraSelectionButton_1 = require("../ExtraSelectionButton");
/**
 * Double extra ingredient buttons for a category of a built product. This takes
 * into consideration whether the selections is for an individual item or a
 * choice of multiple. It will also change state depending whether the
 * item(s) are complementary or cost extra.
 */
const DoubleSelectionButtons = ({ salesOrderItemBuilt, categoryBlueprintStockedProducts, category, addProduct, removeProducts }) => {
    const { productBlueprint } = salesOrderItemBuilt;
    const { name, hasDoubleSelectionButtons } = category;
    const hasCategoryRestrictionRule = (0, react_1.useMemo)(() => productBlueprint.hasCategoryRestrictionRule(name), [name]);
    // if these products are part of a category selection we always want to show the first one at the top so its obvious to the customer
    if (hasCategoryRestrictionRule) {
        categoryBlueprintStockedProducts = salesOrderItemBuilt.getCategoryProductsSortedByLastSelection(name);
    }
    // if no extra selections are allowed in this category there's no point in added the buttons
    const noExtraSelectionsAllowed = (0, react_1.useMemo)(() => productBlueprint.noExtraSelectionsAllowedInCategory(name), [name]);
    if (noExtraSelectionsAllowed) {
        return null;
    }
    // control whether to show quick add buttons based on the category definition.
    // this will work for category selection or single selections
    if (!hasDoubleSelectionButtons) {
        return null;
    }
    return (React.createElement(React.Fragment, null, hasCategoryRestrictionRule ? (React.createElement(ExtraSelectionButton_1.ExtraSelectionButton, { salesOrderItemBuilt: salesOrderItemBuilt, blueprintStockedProduct: categoryBlueprintStockedProducts[0], addProduct: addProduct, removeProducts: removeProducts })) : (React.createElement(React.Fragment, null, categoryBlueprintStockedProducts.map((categoryBlueprintStockedProduct) => (React.createElement(ExtraSelectionButton_1.ExtraSelectionButton, { key: `double-selection-button-${categoryBlueprintStockedProduct.productId}`, salesOrderItemBuilt: salesOrderItemBuilt, blueprintStockedProduct: categoryBlueprintStockedProduct, addProduct: addProduct, removeProducts: removeProducts })))))));
};
exports.DoubleSelectionButtons = DoubleSelectionButtons;
//# sourceMappingURL=index.js.map